import React from 'react';
import ConfettiExplosion from 'react-confetti-explosion';

const RetroConfetti = ({ isExploding }) => {
  const confettiConfig = {
    force: 0.8,
    duration: 3000,
    particleCount: 150,
    width: 1600,
    colors: ['#FFD700', '#FF0000', '#4040FF', '#00FF00'],
    drawShape: (ctx) => {
      ctx.fillStyle = '#000000';
      ctx.strokeStyle = '#FFFFFF';
      ctx.lineWidth = 2;
      ctx.beginPath();
      ctx.rect(0, 0, 10, 10);
      ctx.fill();
      ctx.stroke();
    },
    particleSize: 15,
    spread: 90,
  };

  return (
    <div className="confetti-container confetti-top">
      {isExploding && <ConfettiExplosion {...confettiConfig} />}
    </div>
  );
};

export default RetroConfetti;